module.exports = __webpack_public_path__ + "static/media/xMARK.d9e1577d.png";